export const TYPE_SUBMERCHANT = 2;
